import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '姓名',
      prop: 'name'
    },
    {
      label: '会员账号',
      prop: 'mobile'
    },
    {
      label: '性别',
      prop: 'genderName'
    },
    {
      label: '年龄',
      prop: 'age'
    },
    {
      label: '出生日期',
      prop: 'birthday'
    },
    {
      label: '身份证号',
      prop: 'idCard'
    },
    {
      label: '级别',
      prop: 'level'
    },
    {
        label: '积分',
        prop: 'yearScore'
    },
    {
        label: '会员类型',
        prop: 'memberTypeName'
    }
  ],
  columnsDoubleQuarter: [
    {
      label: '姓名',
      prop: 'name'
    },
    {
      label: '会员账号',
      prop: 'mobile'
    },
    {
      label: '性别',
      prop: 'genderName'
    },
    {
      label: '年龄',
      prop: 'age'
    },
    {
      label: '出生日期',
      prop: 'birthday'
    },
    {
      label: '身份证号',
      prop: 'idCard'
    },
    {
      label: '级别',
      prop: 'level'
    },
    {
        label: '积分',
        prop: 'quarterScore'
    },
    {
        label: '会员类型',
        prop: 'memberTypeName'
    }
  ],
  columnsDoubleMonth: [
    {
      label: '姓名',
      prop: 'name'
    },
    {
      label: '会员账号',
      prop: 'mobile'
    },
    {
      label: '性别',
      prop: 'genderName'
    },
    {
      label: '年龄',
      prop: 'age'
    },
    {
      label: '出生日期',
      prop: 'birthday'
    },
    {
      label: '身份证号',
      prop: 'idCard'
    },
    {
      label: '级别',
      prop: 'level'
    },
    {
        label: '积分',
        prop: 'monthScore'
    },
    {
        label: '会员类型',
        prop: 'memberTypeName'
    }
  ]
}
